import { just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import InlineSpinner from '../../../Cutesies/InlineSpinner';
import ErrorMessage from './ErrorMessage';
import { participantStore } from './Stores/ParticipantStore';

function ParticipantDetailsSection() {
  const email = participantStore.state.participant.email;
  const firstName = participantStore.state.participant.firstName;
  const lastName = participantStore.state.participant.lastName;

  return (
    <div className="bg-card border border-border rounded-lg p-8">
      <div className="flex items-start gap-4 mb-6">
        <div
          className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-lg"
          style={{ fontWeight: 'var(--font-weight-semibold)' }}
        >
          1
        </div>
        <div className="flex-1">
          <h2 className="text-xl mb-1" style={{ fontWeight: 'var(--font-weight-semibold)' }}>
            Participant Details
          </h2>
          <p className="text-muted-foreground">Enter the email and name for the participant.</p>
        </div>
      </div>
      <div className="space-y-5">
        <div>
          <label className="block mb-2" style={{ fontWeight: 'var(--font-weight-medium)' }}>
            Email <span style={{ color: 'var(--destructive)' }}>*</span>
          </label>
          <div className="relative">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => participantStore.updateEmail(e.target.value)}
              onAnimationStart={(e) => {
                if (e.animationName === 'autofill-detect') {
                  participantStore.updateEmail((e.target as HTMLInputElement).value);
                }
              }}
              onBlur={participantStore.lookUpParticipant}
              placeholder="participant@company.com"
              disabled={participantStore.state.kind === 'looking-for-participant'}
              data-intercom-target="participant-email-input"
              className={`autofill-detect w-full px-3 py-2 border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring ${
                participantStore.state.kind === 'directory-lookup-error'
                  ? 'border-destructive'
                  : 'border-border'
              } ${
                participantStore.state.kind === 'looking-for-participant'
                  ? 'opacity-50 cursor-not-allowed'
                  : ''
              }`}
            />
            {participantStore.state.kind === 'looking-for-participant' && (
              <div className="absolute right-3 top-1/2 -translate-y-1/2">
                <InlineSpinner size={20} />
              </div>
            )}
          </div>
          <ErrorMessage
            error={(() => {
              // Only show directory lookup error if email field is not empty
              if (
                participantStore.state.kind === 'directory-lookup-error' &&
                email.trim().length > 0
              ) {
                return just(participantStore.state.message);
              }
              return nothing();
            })()}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block mb-2" style={{ fontWeight: 'var(--font-weight-medium)' }}>
              First name <span style={{ color: 'var(--destructive)' }}>*</span>
            </label>
            <input
              type="text"
              required
              value={firstName}
              onChange={(e) => participantStore.updateFirstName(e.target.value)}
              onAnimationStart={(e) => {
                if (e.animationName === 'autofill-detect') {
                  participantStore.updateFirstName((e.target as HTMLInputElement).value);
                }
              }}
              placeholder="John"
              className="autofill-detect w-full px-3 py-2 border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring"
              data-intercom-target="participant-first-name-input"
            />
          </div>
          <div>
            <label className="block mb-2" style={{ fontWeight: 'var(--font-weight-medium)' }}>
              Last name <span style={{ color: 'var(--destructive)' }}>*</span>
            </label>
            <input
              type="text"
              required
              value={lastName}
              onChange={(e) => participantStore.updateLastName(e.target.value)}
              onAnimationStart={(e) => {
                if (e.animationName === 'autofill-detect') {
                  participantStore.updateLastName((e.target as HTMLInputElement).value);
                }
              }}
              placeholder="Smith"
              className="autofill-detect w-full px-3 py-2 border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring"
              data-intercom-target="participant-last-name-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(ParticipantDetailsSection);
